export default {
	/**
	 * Set all admin fields
	 * @param {Array} surveys 
	 */
	setSurveys(state, surveys) {
		state.all = surveys
	},
}
